import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

// Import shared routes
import { publicRoutes } from './public';
import { systemRoutes } from './system';

// Import PointPay Public pages
const PublicHomePage = lazy(() => import('src/pointpay-public/pages/home'));
const PaymentLinkPage = lazy(() => import('src/pointpay-public/pages/payment-link'));
const DonatePage = lazy(() => import('src/pointpay-public/pages/donate'));
const RegisterPage = lazy(() => import('src/pointpay-public/pages/register'));
const SecureUploadPage = lazy(() => import('src/pointpay-public/pages/secure-upload'));
const SecFileUploadPage = lazy(() => import('src/pointpay-public/pages/sec-file-upload'));
const BusinessInfoPage = lazy(() => import('src/pointpay-public/pages/business-info'));
const ReceiptPage = lazy(() => import('src/pointpay-public/pages/receipt'));

// Import 404 page
const Page404 = lazy(() => import('src/pages/404'));

// ----------------------------------------------------------------------

export default function RouterPointPayPublic() {
  const routes = [
    // Home page at root
    {
      path: '/',
      element: <PublicHomePage />,
    },
    // Payment link page
    {
      path: '/payment-link/:id',
      element: <PaymentLinkPage />,
    },
    // Donate page
    {
      path: '/donate/:shortCode',
      element: <DonatePage />,
    },
    // Business registration page
    {
      path: '/register',
      element: <RegisterPage />,
    },
    // Secure upload (owner verification) page
    {
      path: '/secure-upload',
      element: <SecureUploadPage />,
    },
    // Secure file upload page (public document upload)
    {
      path: '/sec-file-upload',
      element: <SecFileUploadPage />,
    },
    // Business info public page
    {
      path: '/b/:businessName',
      element: <BusinessInfoPage />,
    },
    // Public receipt viewer (replaces the receipt page previously hosted in public-cloud-functions)
    {
      path: '/receipt/:id',
      element: <ReceiptPage />,
    },
    // System routes (update, support, offline)
    ...systemRoutes,
    // Public routes (receipts, etc.)
    ...publicRoutes,
    // Direct 404 route
    { path: '/404', element: <Page404 /> },
    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  return useRoutes(routes);
}
